import {
  ExamResultFileFilterSection,
  ExamResultFileList,
} from '@exam-center/exam-result-file-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex, Paper, Text } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function AdminExamResultFilesPage() {
  return (
    <PermissionGuard
      requiredPermission={[APP_PERMISSIONS.ADMIN_SET_PORTAL_MANAGEMENT.EXAM_RESULT_FILE.VIEW]}
    >
      <Flex sx={{ flexDirection: 'column', minHeight: '100dvh' }}>
        <Flex sx={{ p: (theme) => theme.spacing(6), justifyContent: 'space-between' }}>
          <Text variant='h1'>รายการไฟล์ผลการสอบ</Text>
        </Flex>
        <Flex sx={{ flex: 1, p: (theme) => theme.spacing(6) }}>
          <Paper sx={(theme) => ({ width: '100%', p: theme.spacing(6) })}>
            <Flex
              sx={{ height: '100%', flexDirection: 'column', gap: (theme) => theme.spacing(4) }}
            >
              <ExamResultFileFilterSection />
              <ExamResultFileList />
            </Flex>
          </Paper>
        </Flex>
      </Flex>
    </PermissionGuard>
  );
}
